import { useState } from "react"
import { useTranslation } from "react-i18next"
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"

const INITIAL_COUNT = 3

export function FAQ() {
    const { t } = useTranslation('landing')
    const [isExpanded, setIsExpanded] = useState(false)

    // Get FAQs from translation file as array
    const faqs = t('faq.questions', { returnObjects: true }) as Array<{ q: string; a: string }>
    const displayedFaqs = isExpanded ? faqs : faqs.slice(0, INITIAL_COUNT)
    const hasMore = faqs.length > INITIAL_COUNT

    return (
        <section id="faq" className="relative py-xl overflow-hidden">
            <div className="container relative z-10">
                <div className="max-w-3xl mx-auto">
                    {/* Inline Title */}
                    <div className="flex items-center gap-md mb-lg ml-sm md:ml-0">
                        <h2 className="font-heading-en text-hero text-white whitespace-nowrap">
                            FAQ
                        </h2>
                        <div className="flex-1 h-px bg-white/10" />
                    </div>

                    {/* Compact Accordion */}
                    <Accordion type="single" collapsible className="w-full space-y-xs">
                        {displayedFaqs.map((faq, index) => (
                            <AccordionItem
                                key={index}
                                value={`item-${index}`}
                                className="border-b border-white/[0.06] last:border-0"
                            >
                                <AccordionTrigger className="font-body-ja text-[15px] text-white/80 hover:text-white py-sm hover:no-underline text-left">
                                    {faq.q}
                                </AccordionTrigger>
                                <AccordionContent className="font-body-ja text-caption text-white/50 leading-relaxed pb-sm">
                                    {faq.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    {/* Load More Button */}
                    {hasMore && !isExpanded && (
                        <button
                            onClick={() => setIsExpanded(true)}
                            className="flex items-center justify-center gap-xs w-full mt-md py-sm text-white/50 hover:text-white/80 transition-colors group"
                        >
                            <span className="font-body-ja text-caption">{t('faq.seeMore')}</span>
                            <div className="w-5 h-5 rounded-full border border-white/20 group-hover:border-white/40 flex items-center justify-center transition-colors">
                                <svg
                                    className="w-3 h-3"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                >
                                    <path d="M6 3v6M3 6h6" strokeLinecap="round" />
                                </svg>
                            </div>
                        </button>
                    )}
                </div>
            </div>
        </section>
    )
}
